/* AWA size calculator UI v78 (CLAUDE DRAFT). Needs awa-calc-core.js.
   Jotform form IDs and question IDs are unchanged from v77. */
(function () {
  var NS = window.AWACalcParts = window.AWACalcParts || {};
  var JOT = { split: '262072135963861', tailored: '262071782051856', tracker: '262072870036050', onsite: '262932039236054', results: '262932550552053' };
  var MAX_ROOMS = { single: 4, multi: 4, ducted: 8 };
  var SESSION_KEY = 'awaAirconCalculatorSession';

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function f1(n) { return Number(n).toFixed(1); }
  function f2(n) { return Number(n).toFixed(2); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function radioVal(root, name) { var c = root.querySelector('input[name="' + name + '"]:checked'); return c ? c.value : ''; }
  function sessionId() {
    try { var v = sessionStorage.getItem(SESSION_KEY); if (v) return v; v = 'AWA-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10).toUpperCase(); sessionStorage.setItem(SESSION_KEY, v); return v; }
    catch (e) { return 'AWA-' + Date.now(); }
  }
  function postHidden(action, fields, frameName) {
    var frame = document.getElementById(frameName);
    if (!frame) { frame = el('iframe'); frame.id = frame.name = frameName; frame.title = 'Form submission'; frame.setAttribute('aria-hidden', 'true'); frame.tabIndex = -1; frame.style.display = 'none'; document.body.appendChild(frame); }
    var form = el('form'); form.method = 'POST'; form.action = action; form.target = frameName; form.acceptCharset = 'UTF-8'; form.style.display = 'none';
    Object.keys(fields).forEach(function (k) { var i = el('input'); i.type = 'hidden'; i.name = k; i.value = String(fields[k] == null ? '' : fields[k]); form.appendChild(i); });
    document.body.appendChild(form); form.submit(); form.remove();
  }

  NS.h = { $: $, $$: $$, f1: f1, f2: f2, el: el, radioVal: radioVal, sessionId: sessionId, postHidden: postHidden, JOT: JOT, MAX_ROOMS: MAX_ROOMS };
})();